// extracted by mini-css-extract-plugin
module.exports = {"container":"PartBrowser_container__-96V_","wraper":"PartBrowser_wraper__2rsSq","card":"PartBrowser_card__cyrCq","selected":"PartBrowser_selected__1bvWC"};